import { useReactFlow, MarkerType } from "reactflow";
import { EDGE_TYPES } from "constants/flowDesigner";

export const useHandleFloatingEdge = () => {
  const { setEdges, getEdges } = useReactFlow();

  const createFloatingEdge = (sourceNodeId, targetNodeId) => {
    return {
      pathOptions: { offset: 3 },
      deletable: false,
      id: `${sourceNodeId}->floating->${targetNodeId}`,
      target: targetNodeId,
      source: sourceNodeId,
      type: EDGE_TYPES.FLOATING,
      markerEnd: { type: MarkerType.ArrowClosed, width: 14, height: 14, color: "#7443FF" },
    };
  };

  const addFloatingEdge = (sourceNodeId, targetNodeId) => {
    const filteredEdges = getEdges().filter((edge) =>
      edge.source === sourceNodeId ? edge.type !== EDGE_TYPES.FLOATING : true
    );

    setEdges(filteredEdges.concat(createFloatingEdge(sourceNodeId, targetNodeId)));
  };

  const deleteFloatingEdge = ( sourceNodeId ) => {
    const filteredEdges = getEdges().filter(edge => (
      edge.source === sourceNodeId ? edge.type !== EDGE_TYPES.FLOATING : true
    ))

    setEdges(filteredEdges)
  }

  return {
    addFloatingEdge,
    createFloatingEdge,
    deleteFloatingEdge
  };
};
